<div class="tabs-box">
    <ul class="like-list">
        <li *ngFor="let pointDto of pointDtoList">
            <a>
                <div class="top-box">
                    <div class="like-name" (click)="search(pointDto)" [attr.isIgnoreElement]="true">
                        {{ pointDto.name }}
                    </div>
                    <div class="list-menu">
                        <span class="reg-btn" (click)="edit(pointDto)"></span>
                        <span class="remove-btn" (click)="delete(pointDto.seq)"></span>
                    </div>
                </div>
                <div class="bottom-box">
                    <div class="meter-txt">
                        {{ pointDto.altitude }}m
                    </div>
                    <div class="keyword-txt" (click)="search(pointDto)" [attr.isIgnoreElement]="true">
                        {{ pointDto.address }}
                    </div>
                </div>
            </a>
        </li>
    </ul>
    <div class="layer-menu-box">
        <a class="all-remove-btn" (click)="deleteAll()">
            {{ "search.bookmark.deleteAll" | translate }}
        </a>
        <a class="search-layer-close" (click)="close()" [attr.isIgnoreElement]="true">
            {{ "search.bookmark.unfold" | translate }}
        </a>
    </div>
</div>